<section id="sticky-header">
    <div class="wrapper" #notificationMessageDiv>
        <div *ngIf="submitted && casesAddForm.errors?.invalid" class="alert alert-danger alert-dismissible fade show server-error">
            <strong>Error!</strong> {{casesAddForm.errors?.invalid}}
            <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
        </div>
        <div *ngIf="submitted && isSaved && casesAddForm.valid" class="alert alert-success alert-dismissible fade show server-error" #successMessageDiv>
            <strong>Success!</strong> Saved Successfully!.
            <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
        </div>
    </div>
</section>

<section class="wrapper edit-page">
    <div class="tracker-info-form">
        <h4 class="form-title">Cases Used</h4>
        <div class="responsive-grid">
            <form [formGroup]="casesAddForm">
                <div class="grid-row clearfix">
                    <div class="col-25">
                        <label for="" class="field-label">
                            <span class="mandatory">*</span>
                            CUSTOMER
                        </label>
                        <div class="relative">
                            <input type="text" class="form-control" formControlName="customer" placeholder="">
                        </div>
                        <div *ngIf="submitted && casesAddForm.controls.customer.errors" class="invalid-feedback">
                            <div *ngIf="casesAddForm.controls.customer.errors.required">This is required</div>
                        </div>
                    </div>
                    <div class="col-25">
                        <label for="" class="field-label">
                            <span class="mandatory">*</span>
                            STATE
                        </label>
                        <div class="relative">
                            <input type="text" class="form-control" formControlName="state" placeholder="">
                        </div>
                        <div *ngIf="submitted && casesAddForm.controls.state.errors" class="invalid-feedback">
                            <div *ngIf="casesAddForm.controls.state.errors.required">This is required</div>
                        </div>
                    </div>
                    <div class="col-25">
                        <label for="" class="field-label">
                            <span class="mandatory">*</span>
                            STORE/MODEL
                        </label>
                        <div class="relative">
                            <input type="text" class="form-control" formControlName="store" placeholder="">
                        </div>
                        <div *ngIf="submitted && casesAddForm.controls.store.errors" class="invalid-feedback">
                            <div *ngIf="casesAddForm.controls.store.errors.required">This is required</div>
                        </div>
                    </div>
                    <div class="col-25">
                        <label for="" class="field-label">
                            <span class="mandatory">*</span>
                            PURCHASE ORDER
                        </label>
                        <div>
                            <input type="text" class="form-control" formControlName="purchaseOrder" placeholder="">
                        </div>
                        <div *ngIf="submitted && casesAddForm.controls.purchaseOrder.errors" class="invalid-feedback">
                            <div *ngIf="casesAddForm.controls.purchaseOrder.errors.required">This is required</div>
                        </div>
                    </div>
                </div>
                <div class="grid-row clearfix">
                    <mat-form-field class="example-form-field">
                        <mat-label>Cases Used</mat-label>
                        <mat-chip-grid #reactiveChipGrid aria-label="Enter Case Numbers"
                            formControlName="caseNumbersSet">
                            <mat-chip-row *ngFor="let caseNumber of caseNumbers.value" (removed)="remove(caseNumber)">
                                {{caseNumber}}
                                <button matChipRemove [attr.aria-label]="'remove case number' + caseNumber">
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </mat-chip-row>
                        </mat-chip-grid>
                        <input placeholder="case number ..." [matChipInputFor]="reactiveChipGrid"
                            (matChipInputTokenEnd)="add($event)" />
                    </mat-form-field>
                    <div *ngIf="submitted && casesAddForm.controls.caseNumbersSet.errors" class="invalid-feedback">
                        <div *ngIf="casesAddForm.controls.caseNumbersSet.errors.required">This is required</div>
                        <div *ngIf="casesAddForm.controls.caseNumbersSet.errors.invalidNumber">Case number must be numeric</div>
                        <div *ngIf="casesAddForm.controls.caseNumbersSet.errors.invalidLength">Case number must be 7 digits numeric    
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>

    <div class="mt-25 align-right pb-20 mb-20">
        <button class="btn btn-secondary ml-10" (click)="cancelPage()">Cancel</button>
        <button class="btn btn-primary ml-10" (click)="addCaseNumbers()">Add</button>
    </div>

</section>